import { render, staticRenderFns } from "./PoolView.vue?vue&type=template&id=b3a57834&scoped=true&"
import script from "./PoolView.vue?vue&type=script&lang=js&"
export * from "./PoolView.vue?vue&type=script&lang=js&"
import style0 from "./PoolView.vue?vue&type=style&index=0&id=b3a57834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a57834",
  null
  
)

export default component.exports